<nav class="navbar flex-column navbar-sub-level" [ngClass]="{ 'has-app-banner': showAppBanner }">
    <div class="navbar-header d-none d-lg-block mb-50">
        <!-- <a class="navbar-brand" [routerLink]="homepage">
            <img src="assets/images/stella-images/edp_logo_rgb_dark_neg.svg" width="119" height="25" alt="Edp Online" class="img-fluid" />
        </a> -->
    </div>
    <div class="d-flex d-lg-none justify-content-between w-100 pl-2">
        <button type="button" class="btn btn-back" (click)="closeSidebarSublevel.emit()">
            <i class="icon-edponline-Bop-078 rotate-180 icon-2x" aria-hidden="true"></i>
        </button>
        <button type="button" class="btn btn-close" (click)="closeSidebar.emit()">
            <i class="icon icon-edponline-Bop-071 icon-2x" aria-hidden="true"></i>
        </button>
    </div>

    <div class="nav-container flex-grow-1" *ngIf="menu$ | async as menu">
        <div *edpConditionalRegion="'pt.edp.edponline.contract.consumption.local.pt'">
            <ng-container *ngIf="isEnergy">
                <edp-contract-consumption-local [contract]="contract"></edp-contract-consumption-local>
            </ng-container>
        </div>
        <div *edpConditionalRegion="'pt.edp.edponline.contract.consumption.local.es'">
            <edp-es-contract-consumption-local></edp-es-contract-consumption-local>
        </div>

        <ul class="nav nav-content edp-scroll-disabled">
            <ng-container *ngFor="let item of menu">
                <li [id]="item.reference || ''" class="nav-item" *ngIf="item.visible">
                    <div class="nav-active-bar" *ngIf="!!item.isActive"></div>
                    <a class="nav-link" *ngIf="item.routerPath" (click)="itemAction(item)" [ngClass]="{ active: item.isActive }">
                        <span>{{ item.name | translate }}</span>
                    </a>
                    <a
                        class="nav-link"
                        *ngIf="item.externalLink"
                        [edpExternalLink]="item.externalLink | translate"
                        [ngClass]="{ active: item.isActive }"
                    >
                        <span>{{ item.name | translate }}</span>
                    </a>
                </li>
            </ng-container>
        </ul>

        <ng-container *ngIf="isEnergy && contract">
            <ul class="navbar-nav navbar-bottom mt-auto">
                <li>
                    <!-- <a
                        href="{{ getEnergyLink(contract) }}"
                        [edpExternalLink]="getEnergyLink(contract)"
                        class="nav-link text-center text-lg-left pr-lg-0"
                    >
                        <span>{{ "pt.edp.edponline.sidebar.contract_energy" | translate | uppercase }}</span>
                        <i class="ml-2 icon-edponline-EDP_Online_09 mt-n1" aria-hidden="true"></i>
                    </a> -->
                </li>
            </ul>
        </ng-container>
    </div>
</nav>
